// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"LoginForm_modalContainer__2EfpW","modalCard":"LoginForm_modalCard__3dYcH","formGroup":"LoginForm_formGroup__oI8KF","username":"LoginForm_username__Mf-dT"};